import {arrayToMap, stringComparator} from "../../atUtils";
import {formatFML} from "../../util/UserNameFormat";
import {AccessRights} from "../../constants";
import messageResource from '../../messageResource'

export function groupUsers(users, groups, groupIdProp) {
    const groupsMap = arrayToMap(groups, g => g.id);
    const groupedUsers = [];
    let currentGroup = {};

    [...users].sort(
            (a, b) => stringComparator(groupsMap[a[groupIdProp]].name, groupsMap[b[groupIdProp]].name) ||
                      stringComparator(formatFML(a.firstName, a.middleName, a.lastName), formatFML(b.firstName, b.middleName, b.lastName))
    ).forEach(user => {
        const groupId = user[groupIdProp];
        if (groupId !== currentGroup.id) {
            currentGroup = {
                id: groupId,
                name: groupsMap[groupId].name,
                users: []
            };
            groupedUsers.push(currentGroup);
        }
        currentGroup.users.push(user);
    })

    return groupedUsers;
}

export function extractPermissionsFromUser(user) {
    let manageUsers = false, modifyTimeTrack = false, manageScope = false, costReports = false;

    user.accessRights.forEach(ar => {
        switch (ar) {
            case AccessRights.MANAGE_USERS:
                manageUsers = true;
                break;
            case AccessRights.SUBMIT_OTHER_USER_TIME_TRACK:
                modifyTimeTrack = true;
                break;
            case AccessRights.EDIT_HIERARCHY:
                manageScope = true;
                break;
            case AccessRights.GENERATE_MONEY_REPORTS:
                costReports = true;
                break;
        }
    });

    return {manageUsers, modifyTimeTrack, manageScope, costReports}
}

export function userHasAssignments(user) {
    return user.hasAllAssignments ||
           user.hasCustomerAssignment ||
           user.hasAllFutureProjectsOfCustomerAssignment ||
           user.hasProjectAssignment ||
           user.hasAllFutureTasksOfProjectAssignment ||
           user.hasTaskAssignment
}

export function getTitleOfGenerateMoneyReportsRight(isBTYEnabled, isURAEnabled) {
    let title = ""
    if (isBTYEnabled && isURAEnabled)
        title = messageResource.getMessage('access_rights.generate_money_reports')
    if (isBTYEnabled && !isURAEnabled)
        title = messageResource.getMessage('access_rights.generate_money_reports_only_billing')
    if (!isBTYEnabled && isURAEnabled)
        title = messageResource.getMessage('access_rights.generate_money_reports_only_cost')

    return title
}

export function getTitleOfModifyTimeTrackRight(isTTAEnabled) {
    return messageResource.getMessage(isTTAEnabled ? 'access_rights.modify_and_approve_tt' : 'access_rights.submit_other_time_track')
}


// WEBPACK FOOTER //
// ./web/js/panels/usersAssignedToHierarchy/utils.js